<template>
  <div class="ba-top-6 ba-right-6 ba-z-50 ba-absolute ba-flex ba-items-center ba-justify-center ba-flex-nowrap">
    <div
      v-for="(val, index) in languages"
      :key="index"
      class="ba-text-faint-weak ba-border ba-border-base-weak ba-rounded"
      :class="{ 'ba-border-transparent': selectedLanguage !== val }"
    >
      <input
        :id="val"
        v-model="selectedLanguage"
        type="radio"
        :value="val"
        class="sr-only"
      />
      <label :for="val" class="ba-px-1 ba-py-1 ba-uppercase leading-none cursor-pointer ba-text-inherit">
        {{ val }}
      </label>
    </div>
  </div>
</template>

<script>

import { setLocale } from "@/utils/i18n";
import Locale from "@/utils/locale";

export default {
  name: "ap-language-switch",
  data() {
    return {
      selectedLanguage: this.$i18n.locale,
      languages: this.$i18n.availableLocales
    };
  },
  watch: {
    selectedLanguage(val) {
      Locale.setLocale(val)
      setLocale(val)
    }
  },
  methods: {
    getInputValue(language) {
      return this.languages.filter((lang) => lang !== language)[0];
    }
  }
};

</script>
